"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Feb 14 2019
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var index_1 = require("../../core/utils/index");

var WindowSimulation_1 = require("../model/WindowSimulation");

var SimulationStringConverter_1 = require("./SimulationStringConverter");

var WindowSimulationConverter_1 = require("./WindowSimulationConverter");
/**
 * Default implementation of WindowSimulationConverter.
 *
 * @author BPo
 */


var WindowSimulationConverterImpl =
/*#__PURE__*/
function (_WindowSimulationConv) {
  _inherits(WindowSimulationConverterImpl, _WindowSimulationConv);

  function WindowSimulationConverterImpl(simulationStringConverter) {
    var _this;

    _classCallCheck(this, WindowSimulationConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowSimulationConverterImpl).call(this));
    _this.simulationStringConverter = simulationStringConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(WindowSimulationConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      var id = index_1.Utils.VOID_ID;

      try {
        id = conversions.documentToClassId(source);
      } catch (ex) {// ignored - try-catch for backward compatibility only
      }

      return new WindowSimulation_1.WindowSimulation(id === index_1.Utils.VOID_ID ? index_1.Utils.VOID_ID
      /* for backward compatibility only */
      : WindowSimulation_1.WindowSimulation.schema.id.valueOf(id), WindowSimulation_1.WindowSimulation.schema.simulationId.valueOf(conversions.toClassReferenceId(source.simulationId)), WindowSimulation_1.WindowSimulation.schema.originId.valueOf(conversions.toClassReferenceId(source.originId)), WindowSimulation_1.WindowSimulation.schema.state.valueOf(source.state), conversions.asObjectOpt(source, 'windowTypeId', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationStringConverter.toObject(document, conversions);
      }), conversions.asObjectOpt(source, 'name', function (document) {
        return index_1.Utils.isValueMissing(document) ? null : _this2.simulationStringConverter.toObject(document, conversions);
      }), index_1.Utils.isValueMissing(source.processedByCM) ? false : WindowSimulation_1.WindowSimulation.schema.processedByCM.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        simulationId: conversions.toDocumentReferenceId(source.simulationId),
        originId: index_1.Utils.isValueMissing(source.originId) ? null : conversions.toDocumentReferenceId(source.originId),
        state: source.state,
        windowTypeId: conversions.asObjectOpt(source, 'windowTypeId', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationStringConverter.toDocument(object, conversions);
        }),
        name: conversions.asObjectOpt(source, 'name', function (object) {
          return index_1.Utils.isValueMissing(object) ? null : _this3.simulationStringConverter.toDocument(object, conversions);
        }),
        processedByCM: source.processedByCM
      });
      return result;
    }
  }]);

  return WindowSimulationConverterImpl;
}(WindowSimulationConverter_1.WindowSimulationConverter);

WindowSimulationConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [SimulationStringConverter_1.SimulationStringConverter])], WindowSimulationConverterImpl);
exports.WindowSimulationConverterImpl = WindowSimulationConverterImpl;